<template>
  <div class="animated fadeIn">
    <template v-for="item in linksList">
        <a :href="item.href">{{item.title}}</a><br>
    </template>
  </div>
</template>

<script>
import { tokenMixin } from '@/mixins/tokenMixin';

export default {
  name: 'Links',
  mixins: [tokenMixin],
  data () {
    return {
      linksList: []
    }
  },
  mounted: function () {
    //from the mixin
    if (this.checkForToken())
    {
      var config = {
        headers: {'Authorization': 'bearer ' + this.$localStorage.get('token')}
      };
      this.axios.get(process.env.VUE_APP_API_BASE + 'links', config).then(response => {
        return response
      })
      .then(res => {
        if (res.status === 200)
        {
          this.linksList = res.data;
        }
      })
      .catch(error => {
        console.log(error.response)
      });
    }
  }
}
</script>
